import { applicationSetting } from '@unipile/db';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const ApplicationSettingSchema = createSelectSchema(applicationSetting);

export const InsertApplicationSettingSchema = createInsertSchema(applicationSetting);

export type ApplicationSetting = typeof applicationSetting.$inferSelect;
export type InsertApplicationSetting = typeof applicationSetting.$inferInsert;
